import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { showErrorAlert } from '../../../redux/Actions';
import { getBookingsUserWiseCollAgents } from '../../../redux/Report/ReportActions';
import LoaderScreen from '../../../common/LoaderScreen';
import { Box, Divider, Typography } from '@mui/material';
import { branchOffRefundColDef, branchOffRefundDetailsColDef, branchOffRefundDetailsTotalColDef, branchOffRefundTotalColDef, userCollBranchOffSummaryColDef, userCollBranchOffSummaryTotalColDef, userCollectionColDef, userCollectionRefundColDef, userCollectionRefundTotalColDef, userCollectionTotalColDef, usercollFilterCol, userCollSummaryColDef, userCollSummaryTotalColDef } from '../constants';
import VirtualizedTable from '../../../common/VirtualizedTable';
import { formatDecimal } from '../../../utils/helpers';
import ReportTableFilter from '../../../common/ReportTableFilter';
import dayjs from 'dayjs';
import { reportGenerationDateFormat } from '../../../common/constant';
import ExcelAndPrint from '../../../common/ExcelAndPrint';
import ReportHeader from '../../../common/ReportHeader';
import { decryptText } from '../../../utils/Decrypt';

const UserCollection = () => {
  const [searchParams] = useSearchParams();
  const dispatch = useDispatch();

  const [paramsLoaded, setParamsLoaded] = useState(false);
  const [reportData, setReportData] = useState({})

  let decryptedData = {}
  try {
    const paramData = searchParams.get("data");
    if (paramData) {
      decryptedData = JSON.parse(decryptText(decodeURIComponent(paramData)));
    }
  } catch (error) {
    console.error("Invalid query data:", error);
  }

  const { fromDate, toDate, agentUserID, agentUser, agentID } = decryptedData

  // 🔹 Mark params as loaded once searchParams exists
  useEffect(() => {
    if (searchParams.toString()) {
      setParamsLoaded(true);
    }
  }, [searchParams]);

  useEffect(() => {
    if (!paramsLoaded) return;


    const requiredFields = [fromDate, toDate, agentUserID, agentID];

    const hasError = requiredFields.some(
      (val) => val === undefined || val === null
    );

    if (hasError) {
      dispatch(showErrorAlert('Invalid URL: Missing required parameters'));
      return;
    }

    const body = {
      intAgentUserID: Number(agentUserID),
      intAgentID: Number(agentID),
      dtFromDate: fromDate,
      dtToDate: toDate,
    };

    dispatch(getBookingsUserWiseCollAgents(body)).then((res) => {
      if (res.data.status) {
        let { userCollData = [], refundData = [], sumaryData = [], branchOffRefundData = [], branchOffRefundDetailsData = [], BranchOffSummaryData = [] } = handleGroupData(JSON.parse(res?.data?.Data || "{}") || {})
        setReportData({ userCollData, refundData, sumaryData, branchOffRefundData, branchOffRefundDetailsData, BranchOffSummaryData })

      } else {
        dispatch(showErrorAlert(res.data.Message))
      }
    })
      .catch(() => {
        dispatch(showErrorAlert('Failed to load user collection report'));
      });

  }, [
    paramsLoaded,
    fromDate,
    toDate,
    agentUserID,
    agentID,
    dispatch,
  ]);

  if (!paramsLoaded) {
    return <LoaderScreen />;
  }

  const handleGroupData = (data = {}) => {
    let totalRow = {
      Seatcount: 0,
      AgentComm: 0,
      TotalFare: 0,
    }
    let userCollData = data?.Table?.map((obj, index) => {
      let totalFare = Number(obj.TotalFare) + Number(obj.PDCharge)
      totalRow = {
        ...totalRow,
        Seatcount: formatDecimal(Number(totalRow.Seatcount) + Number(obj.Seatcount)),
        AgentComm: formatDecimal(Number(totalRow.AgentComm) + Number(obj.AgentComm)),
        TotalFare: formatDecimal(Number(totalRow.TotalFare) + Number(totalFare)),
      }
      return { ...obj, SrNo: index + 1, TotalFare: totalFare }
    })
    if (userCollData.length !== 0) {
      userCollData.push({
        isTotalRow: true,
        align: "left",
        totalCaption: "Total",
        colSpan: 8,
        ...totalRow,
      })
    }
    let refundTotalRow = {
      Seatcount: 0,
      charge: 0,
      TotalFare: 0,
    }
    let refundData = data?.Table1?.map((obj, index) => {
      let charge = Number(obj.TotalFare) - Number(obj.RefundAmount)
      refundTotalRow = {
        ...refundTotalRow,
        Seatcount: formatDecimal(Number(refundTotalRow.Seatcount) + Number(obj.Seatcount)),
        charge: formatDecimal(Number(refundTotalRow.charge) + Number(charge)),
        TotalFare: formatDecimal(Number(refundTotalRow.TotalFare) + Number(obj.TotalFare)),
      }
      return { ...obj, SrNo: index + 1, charge: formatDecimal(charge) }
    })
    if (refundData.length !== 0) {
      refundData.push({
        isTotalRow: true,
        totalCaption: "Total",
        colSpan: 8,
        align: "left",
        ...refundTotalRow,
      })
    }
    let summaryRecived = formatDecimal(Number(totalRow.TotalFare ?? 0) + Number(refundTotalRow.charge ?? 0))
    let summaryNetBalance = formatDecimal((Number(totalRow.TotalFare ?? 0) + Number(refundTotalRow.charge ?? 0)) - Number(refundTotalRow?.TotalFare ?? 0))
    let sumaryData = [
      { type: "COLLECTION", Recived: totalRow.TotalFare ?? 0, Payment: 0 },
      { type: "REFUND CHARGE", Recived: refundTotalRow.charge ?? 0, Payment: 0 },
      { type: "REFUND", Recived: 0, Payment: refundTotalRow?.TotalFare ?? 0 },
      { type: "", Recived: summaryRecived, Payment: refundTotalRow?.TotalFare ?? 0 },
      { isTotalRow: true, totalCaption: "NET BALANCE:", align: "left", colSpan: 2, Payment: summaryNetBalance }
    ]
    let branchOffRefundTotalRow = {
      Seatcount: 0,
      AgentComm: 0,
      TotalFare: 0,
    }

    let branchOffRefundData = data?.Table2?.map((obj, index) => {
      branchOffRefundTotalRow = {
        ...branchOffRefundTotalRow,
        Seatcount: formatDecimal(Number(branchOffRefundTotalRow.Seatcount) + Number(obj.Seatcount)),
        AgentComm: formatDecimal(Number(branchOffRefundTotalRow.AgentComm) + Number(obj.AgentComm)),
        TotalFare: formatDecimal(Number(branchOffRefundTotalRow.TotalFare) + Number(obj.TotalFare)),
      }
      return { ...obj, SrNo: index + 1, }
    })
    if (branchOffRefundData.length !== 0) {
      branchOffRefundData.push({
        isTotalRow: true,
        totalCaption: "Total",
        align: "left",
        colSpan: 8,
        ...branchOffRefundTotalRow,
      })
    }



    let branchOffRefundDetailsTotalRow = {
      Seatcount: 0,
      Charge: 0,
      TotalFare: 0,
    }

    let branchOffRefundDetailsData = data?.Table3?.map((obj, index) => {
      let charge = Number(obj.TotalFare) - Number(obj.RefundAmount)

      branchOffRefundDetailsTotalRow = {
        ...branchOffRefundDetailsTotalRow,
        Seatcount: formatDecimal(Number(branchOffRefundDetailsTotalRow.Seatcount) + Number(obj.Seatcount)),
        Charge: formatDecimal(Number(branchOffRefundDetailsTotalRow.Charge) + Number(charge)),
        TotalFare: formatDecimal(Number(branchOffRefundDetailsTotalRow.TotalFare) + Number(obj.TotalFare)),
      }
      return { ...obj, SrNo: index + 1, Charge: charge }
    })
    if (branchOffRefundDetailsData.length !== 0) {
      branchOffRefundDetailsData.push({
        isTotalRow: true,
        totalCaption: "Total",
        align: "left",
        colSpan: 8,
        ...branchOffRefundDetailsTotalRow,
      })
    }
    let branchOffSummaryRecived = formatDecimal(Number(branchOffRefundTotalRow.TotalFare ?? 0) + Number(branchOffRefundDetailsTotalRow.Charge ?? 0))
    let branchOffSummaryNetBalance = formatDecimal(branchOffSummaryRecived - branchOffRefundDetailsTotalRow?.TotalFare ?? 0)
    let grandTotal = formatDecimal(branchOffSummaryNetBalance) + formatDecimal(summaryNetBalance)
    let BranchOffSummaryData = [
      { type: "COLLECTION", Recived: branchOffRefundTotalRow.TotalFare ?? 0, Payment: 0 },
      { type: "REFUND CHARGE", Recived: branchOffRefundDetailsTotalRow.Charge ?? 0, Payment: 0 },
      { type: "REFUND", Recived: 0, Payment: branchOffRefundDetailsTotalRow?.TotalFare ?? 0 },
      { type: "", Recived: branchOffSummaryRecived, Payment: branchOffRefundDetailsTotalRow?.TotalFare ?? 0 },
      { isTotalRow: true, totalCaption: "NET BALANCE:", colSpan: 2, align: "left", Payment: branchOffSummaryNetBalance },
      { isTotalRow: true, totalCaption: "Grand Total", colSpan: 2, align: 'left', Payment: grandTotal }

    ]
    return { userCollData, refundData, sumaryData, branchOffRefundData, branchOffRefundDetailsData, BranchOffSummaryData }
  }
  const filterData = {
    user: agentUser,
    journeyDate: `${dayjs(fromDate, 'YYYY-MM-DD').format('DD-MMM-YYYY')} to ${dayjs(toDate, 'YYYY-MM-DD').format('DD-MMM-YYYY')}`,
    reportDate: dayjs(window.getTime ? window.getTime() : new Date()).format(reportGenerationDateFormat),
  }
  return (
    <>
      <ReportHeader reportitle='User Collection Report' />
      <Box sx={{ padding: '12px 16px 8px 16px' }}>
        <ReportTableFilter
          columnDef={usercollFilterCol}
          data={filterData}
        />
      </Box>
      <Box sx={{ padding: '8px 16px', display: 'flex', justifyContent: 'space-between', alignItems: "center" }}>
        <Typography variant="h6" >
          AGENT USER COLLECTION DETAILS
        </Typography>
        <ExcelAndPrint
          reportTitle='User Collection Report'
          multiTable={[{
            titleTable: 'AGENT USER COLLECTION DETAILS',
            columnDef: userCollectionColDef,
            body: reportData.userCollData,
          },
          {
            titleTable: 'AGENT USER REFUND DETAILS',
            columnDef: userCollectionRefundColDef,
            body: reportData.refundData,
          },
          {
            titleTable: 'SUMMARY OF COLLECTION AND REFUND',
            columnDef: userCollSummaryColDef,
            body: reportData.sumaryData,
          },
          {
            titleTable: 'AGENT USER COLLECTION DETAILS(BRANCH OFFLINE)',
            columnDef: branchOffRefundColDef,
            body: reportData.branchOffRefundData,
          },

          {
            titleTable: 'AGENT USER REFUND DETAILS(BRANCH OFFLINE)',
            columnDef: branchOffRefundDetailsColDef,
            body: reportData.branchOffRefundDetailsData,
          },

          {
            titleTable: 'SUMMARY OF COLLECTION AND REFUND(BRANCH OFFLINE)',
            columnDef: userCollBranchOffSummaryColDef,
            body: reportData.BranchOffSummaryData,
          },
          ]}
          filterSectionColumn={usercollFilterCol}
          filterSectionData={filterData}

        />
      </Box>

      <Divider />
      <Box sx={{ padding: '12px 16px' }}>
        <VirtualizedTable
          tableData={reportData.userCollData}
          columnDefs={userCollectionColDef}
          totalColumnDef={userCollectionTotalColDef}
        />
      </Box>
      <Box sx={{ padding: '8px 16px' }}>
        <Typography variant="h6" >
          AGENT USER REFUND DETAILS
        </Typography>
      </Box>
      <Divider />
      <Box sx={{ padding: '12px 16px' }}>
        <VirtualizedTable
          tableData={reportData.refundData}
          columnDefs={userCollectionRefundColDef}
          totalColumnDef={userCollectionRefundTotalColDef}
        />
      </Box>
      <Box sx={{ padding: '8px 16px' }}>
        <Typography variant="h6" >
          SUMMARY OF COLLECTION AND REFUND
        </Typography>
      </Box>
      <Divider />
      <Box sx={{ padding: '12px 16px' }}>
        <VirtualizedTable
          tableData={reportData.sumaryData}
          columnDefs={userCollSummaryColDef}
          totalColumnDef={userCollSummaryTotalColDef}
        />
      </Box>

      <Box sx={{ padding: '8px 16px' }}>
        <Typography variant="h6" >
          AGENT USER COLLECTION DETAILS(BRANCH OFFLINE)
        </Typography>
      </Box>
      <Divider />
      <Box sx={{ padding: '12px 16px' }}>
        <VirtualizedTable
          tableData={reportData.branchOffRefundData}
          columnDefs={branchOffRefundColDef}
          totalColumnDef={branchOffRefundTotalColDef}
        />
      </Box>



      <Box sx={{ padding: '8px 16px' }}>
        <Typography variant="h6" >
          AGENT USER REFUND DETAILS(BRANCH OFFLINE)
        </Typography>
      </Box>
      <Divider />
      <Box sx={{ padding: '12px 16px' }}>
        <VirtualizedTable
          tableData={reportData.branchOffRefundDetailsData}
          columnDefs={branchOffRefundDetailsColDef}
          totalColumnDef={branchOffRefundDetailsTotalColDef}
        />
      </Box>


      <Box sx={{ padding: '8px 16px' }}>
        <Typography variant="h6" >
          SUMMARY OF COLLECTION AND REFUND(BRANCH OFFLINE)
        </Typography>
      </Box>
      <Divider />
      <Box sx={{ padding: '12px 16px' }}>
        <VirtualizedTable
          tableData={reportData.BranchOffSummaryData}
          columnDefs={userCollBranchOffSummaryColDef}
          totalColumnDef={userCollBranchOffSummaryTotalColDef}
        />
      </Box>
    </>
  );
};

export default UserCollection;
